var map = {
	"./Home/404.vue": [
		"1622"
	],
	"./Home/Banner/banner.vue": [
		"6de3",
		"chunk-626ea6c1"
	],
	"./Home/Desk/desk.vue": [
		"e865",
		"chunk-632badfa"
	],
	"./Home/Home.vue": [
		"1c62"
	],
	"./Home/HotSale/hotSale.vue": [
		"0b13",
		"chunk-35c82e7b"
	],
	"./Home/Index/index.vue": [
		"7603",
		"chunk-7cf73609"
	],
	"./Home/Order/gathering.vue": [
		"15f6",
		"chunk-022f2b7b"
	],
	"./Home/Order/order.vue": [
		"4a5d",
		"chunk-9c9b58a2"
	],
	"./Home/Order/orderFlowList.vue": [
		"aa30",
		"chunk-0159c67e"
	],
	"./Home/Order/orderInfo.vue": [
		"ec48",
		"chunk-6da3d0aa"
	],
	"./Home/Pos/index.vue": [
		"afe1",
		"chunk-f885946e"
	],
	"./Home/Recommend/recommend.vue": [
		"2ed7",
		"chunk-7416f67a"
	],
	"./Home/User/user.vue": [
		"6928",
		"chunk-e0779886"
	],
	"./Home/advertising/advertising.vue": [
		"e70f",
		"chunk-4d8d8d3b"
	],
	"./Home/orderList/orderList.vue": [
		"0a3f",
		"chunk-6d22fe5a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "da65";
module.exports = webpackAsyncContext;